import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import themeProps from "theme/themes";

interface InfoBoxProps {
  title: string;
  editable?: boolean;
  onEdit?: any;
  children: ReactElement;
}

const Wrapper = styled.div`
  border: 1px solid ${(state: themeProps) => state.theme.main.primary};
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 16px;
`;

const Row = styled.div`
  display: flex;
`;

const Title = styled.h3`
  color: ${(state: themeProps) => state.theme.main.primary};
  font-size: 2rem;
  margin-bottom: 16px;
`;

const EditButton = styled.button`
  font-size: 1rem;
  background-color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 16px;
  margin-bottom: 16px;
  color: #1a1a1a;
`;

const InfoBox = ({ title, editable, onEdit, children }: InfoBoxProps) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper>
      <Row>
        <Title>{title}</Title>
        {editable && <EditButton>{t("edit")}</EditButton>}
      </Row>
      {children}
    </Wrapper>
  );
};

export default InfoBox;
